import { FC, useContext, useState } from "react";
import { UserContext, TeamContext } from "../../../../context";
import EditPen from '../../../../assets/icons/edit_pen.svg';
import { PinkNotification } from "../../../atoms";
import { useTranslation } from "react-i18next";

const LobbyHeaderTeamName: FC<{}> = () => {
	const { t } = useTranslation();
	const { game } = useContext(TeamContext);
	const { changeTeamNickNameSocketEmit } = useContext(UserContext);
	const [newTeamName, setNewTeamName] = useState<string>("");
	const [isNewTeamNumberAllowed, setIsNewTeamNumberAllowed] = useState<boolean>(false);

	const switchLobbyTitle = () => {
		setIsNewTeamNumberAllowed(!isNewTeamNumberAllowed);
	}

	const change = (event: any) => {
		setNewTeamName(event.target.value);
	};

	const handleKeyPress = (event: any) => {
		if (event.key === 'Enter') 
			switchLobbyTitle();

		if (!newTeamName)
			return;

		if (event.key === 'Enter') 
			changeTeamNickNameSocketEmit(newTeamName);
	}

	const saveCurrentChange = () => {
		switchLobbyTitle();

		if (!newTeamName)
			return;

		changeTeamNickNameSocketEmit(newTeamName);
	}

	return (

		<div className="team_name_wrapper">

			<div className="edit_team">
				{isNewTeamNumberAllowed  ?
					<div className="edit_team_field" style={{position: "relative"}}>
						<PinkNotification notificationWidthVW={25} notificationRenderingSide="left" text={t("editTeamNameNotificationText")} />
						<input
							autoFocus
							maxLength={20}
							onBlur={saveCurrentChange}
							style={{
								height: "45px",
								width: "300px",
								border: "none",
								borderRadius: "35px",
								padding: "0 15px",
								background: "#003547",
								outline: "none",
								fontSize: "20px",
								textAlign: "center",
								zIndex: 1,
							}}
							type='text'
							value={newTeamName}
							placeholder={t("enterTheNewTeamNameText")}
							onKeyPress={handleKeyPress}
							onChange={change}
						/>
					</div>
					:
					<div className="edit_team_field">
						<div className="current_team_name"> {t("teamWithColonText")} {game?.nickname} </div>
						<img className="edit_pen" src={EditPen} alt="edit pen" onClick={switchLobbyTitle} />
					</div>
				}
			</div>

			<div className="edit_team_notification lobby_gray_color"> {t("waitingForPlayersToBeReadyText")} </div>

		</div>
	);
};

export default LobbyHeaderTeamName;
